"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteTypeMappings = void 0;
const catalog_messages_1 = require("@tableau/catalog-messages");
exports.RemoteTypeMappings = {
    ARRAY: catalog_messages_1.Messages.RemoteTypeString,
    BOOL: catalog_messages_1.Messages.RemoteTypeBoolean,
    BSTR: catalog_messages_1.Messages.RemoteTypeString,
    BYREF: catalog_messages_1.Messages.RemoteTypeString,
    BYTES: catalog_messages_1.Messages.RemoteTypeString,
    CY: catalog_messages_1.Messages.RemoteTypeReal,
    DATE: catalog_messages_1.Messages.RemoteTypeDate,
    DBDATE: catalog_messages_1.Messages.RemoteTypeDate,
    DBTIME: catalog_messages_1.Messages.RemoteTypeDateTime,
    DBTIMESTAMP: catalog_messages_1.Messages.RemoteTypeDateTime,
    DECIMAL: catalog_messages_1.Messages.RemoteTypeReal,
    EMPTY: catalog_messages_1.Messages.RemoteTypeUnknown,
    ERROR: catalog_messages_1.Messages.RemoteTypeUnknown,
    FILETIME: catalog_messages_1.Messages.RemoteTypeDateTime,
    GUID: catalog_messages_1.Messages.RemoteTypeString,
    HCHAPTER: catalog_messages_1.Messages.RemoteTypeUnknown,
    I1: catalog_messages_1.Messages.RemoteTypeInteger,
    I2: catalog_messages_1.Messages.RemoteTypeInteger,
    I4: catalog_messages_1.Messages.RemoteTypeInteger,
    I8: catalog_messages_1.Messages.RemoteTypeInteger,
    IDISPATCH: catalog_messages_1.Messages.RemoteTypeUnknown,
    IUNKNOWN: catalog_messages_1.Messages.RemoteTypeUnknown,
    NULL: catalog_messages_1.Messages.RemoteTypeInteger,
    NUMERIC: catalog_messages_1.Messages.RemoteTypeReal,
    PROPVARIANT: catalog_messages_1.Messages.RemoteTypeUnknown,
    R4: catalog_messages_1.Messages.RemoteTypeReal,
    R8: catalog_messages_1.Messages.RemoteTypeReal,
    RESERVED: catalog_messages_1.Messages.RemoteTypeUnknown,
    STR: catalog_messages_1.Messages.RemoteTypeString,
    UDT: catalog_messages_1.Messages.RemoteTypeInteger,
    UI1: catalog_messages_1.Messages.RemoteTypeInteger,
    UI2: catalog_messages_1.Messages.RemoteTypeInteger,
    UI4: catalog_messages_1.Messages.RemoteTypeInteger,
    UI8: catalog_messages_1.Messages.RemoteTypeInteger,
    VARIANT: catalog_messages_1.Messages.RemoteTypeUnknown,
    VARNUMERIC: catalog_messages_1.Messages.RemoteTypeReal,
    VECTOR: catalog_messages_1.Messages.RemoteTypeString,
    WDC_BOOL: catalog_messages_1.Messages.RemoteTypeBoolean,
    WDC_DATE: catalog_messages_1.Messages.RemoteTypeDate,
    WDC_DATETIME: catalog_messages_1.Messages.RemoteTypeDateTime,
    WDC_FLOAT: catalog_messages_1.Messages.RemoteTypeReal,
    WDC_GEOMETRY: catalog_messages_1.Messages.RemoteTypeUnknown,
    WDC_INT: catalog_messages_1.Messages.RemoteTypeInteger,
    WDC_STRING: catalog_messages_1.Messages.RemoteTypeString,
    WSTR: catalog_messages_1.Messages.RemoteTypeString,
};
//# sourceMappingURL=RemoteTypeMapping.js.map